<template>
  <div
    class="modal"
    v-bind:class="{ 'is-active': this.$store.state.popup.isActiveEditQuestion }"
  >
    <div class="modal-background" @click="popupClose"></div>
    <div style="max-width:600px" class="modal-content">
      <div class="modalEditQuestion">
        <img
          @click="popupClose()"
          src="@/assets/img/icons/close-icon.png"
          alt="close-icon"
          class="icon-close"
        />
        <div class="field">
          <b-field :label="$t('question.intitule')">
            <b-input
              maxlength="4000"
              type="textarea"
              :value="this.$store.state.popup.intituleEditQuestion"
              @input="onFormChange"
            ></b-input>
          </b-field>
        </div>
        <div>
          <div>
            <button
              class="button is-primary"
              @click="
                SubmitForm();
                popupClose();
              "
            >
              {{ $t("button.modifier") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <button
      class="modal-close is-large"
      aria-label="close"
      @click="popupClose"
    ></button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  methods: {
    popupClose(evt) {
      this.$store.dispatch("popupToggleEditQuestion");
    },
    SubmitForm(evt) {
      this.$store.dispatch(
        "update_intitule_question",
        this.$route.params.url_moderateur
      );
    },
    onFormChange(textareaValue) {
      this.$store.commit(`HYDRATE_INTITULE_EDIT_QUESTION`, textareaValue);
    }
  }
};
</script>
<style scoped>
.modalEditQuestion {
  text-align: center;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  margin: 50px;
  padding: 15px;
  background: #fff;
}
.icon-close {
  width: 20px;
  height: 20px;
  cursor: pointer;
  float: right;
}
.button {
  margin: auto;
  border-radius: 0px;
  font-size: 12px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/base/PopupEditQuestion.vue